import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'
import LogoImg from '../../../assets/login/logo.png'
import GoogleLogoImg from '../../../assets/login/googlelogo.png'
import axios from 'axios'
import UserContext from '../../../contexts/UserContext'
import jwtDecode from 'jwt-decode'
import { GoogleLogin } from '@react-oauth/google'

import {
  Container,
  MainText,
  LoginForm,
  Label,
  TextInput,
  InputButton,
  PassReset,
  OrLine,
  LeftLine,
  RightLine,
  OrText,
  GoogleDiv,
  RegisterDiv,
  ErrContainer,
} from './style'
import { Logo } from '../style'
import CompleteRegister from '../CompleteRegister'

interface MainBoxProps {
  setPage: (page: string) => void
  setUserlogin: Dispatch<SetStateAction<LoginInfo>>
}

interface LoginInfo {
  email: string
  password: string
}

interface GoogleUser {
  aud: string
  azp: string
  email: string
  email_verified: boolean
  exp: number
  family_name: string
  given_name: string
  iat: number
  iss: string
  jti: string
  name: string
  nbf: number
  picture: string
  sub: string
}

const MainBox: React.FC<MainBoxProps> = (props) => {
  const {
    user,
    setUser,
    googleEmail,
    setGoogleEmail,
    googleName,
    setGoogleName,
    googlePicture,
    setGooglePicture,
    setToken,
  } = useContext(UserContext)
  const [userLogin, setUserLogin] = useState<string>('')
  const [userPassword, setUserPassword] = useState<string>('')
  const [nameButton, setNameButton] = useState<string>('Entrar')
  const [errLogin, setErrLogin] = useState<number>(0)

  useEffect(() => {
    const token = localStorage.getItem('token')

    if (token) {
      try {
        const decodedToken = jwtDecode(token) as {
          exp: number
          approved: string
        }
        const now = Date.now().valueOf() / 1000

        if (decodedToken.exp > now && decodedToken.approved === 'approved') {
          // Token ainda é válido e usuário está aprovado, redireciona o usuário para a página de home
          window.location.href = '/panel'
        } else {
          // Token expirado ou usuário não aprovado, usuário deve fazer login novamente
          localStorage.removeItem('token')
        }
      } catch (err) {
        console.error(err)
        // Algum problema ocorreu ao decodificar o token, usuário deve fazer login novamente
        localStorage.removeItem('token')
      }
    }
  }, [])

  const changePage = (_Page: string) => {
    props.setPage(_Page)
  }

  const handleLogin = async () => {
    if (userLogin && userPassword) {
      setNameButton('Entrando')
      setErrLogin(0)
      axios
        .post(`${process.env.REACT_APP_BASE_URL}/login`, { //${process.env.REACT_APP_BASE_URL} - TODO
          email: userLogin,
          password: userPassword,
        })
        .then((res) => {
          if (res.data.access_token) {
            const token = res.data.access_token
            localStorage.setItem('token', token)
            const userDecode = jwtDecode(token) as any
            setUser(userDecode)
            setToken(token)
            if (userDecode.approved === 'approved') {
              window.location.href = '/panel'
            } else {
              window.location.href = '/accessvalidation'
            }
          }
        })
        .catch((err) => {
          setNameButton('Entrar')
          setErrLogin(400)
        })
    }
  }

  return !googleEmail ? (
    <Container>
      <Logo src={LogoImg} alt='Logo da Dustre' />
      <MainText> Entre ou cadastre-se no site </MainText>

      <LoginForm>
        <Label htmlFor='email'>Email</Label>
        <TextInput
          type='text'
          name='email'
          value={userLogin}
          onChange={(e) => setUserLogin(e.target.value)}
        />

        <Label htmlFor='password'>Senha</Label>
        <TextInput
          type='password'
          name='password'
          value={userPassword}
          onChange={(e) => setUserPassword(e.target.value)}
        />
        {errLogin === 400 ? (
          <ErrContainer>Email e/ou senha inválidos</ErrContainer>
        ) : null}

        <InputButton
          onClick={() => handleLogin()}
          type='button'
          value={nameButton}
        />
      </LoginForm>

      <PassReset onClick={() => changePage('PassReset')}>
        {' '}
        Esqueci a senha{' '}
      </PassReset>

      {/* Linha com o "ou" escrito no meio */}
      <OrLine>
        <LeftLine />
        <OrText>ou</OrText>
        <RightLine />
      </OrLine>

      <GoogleDiv>
        <GoogleLogin
          onSuccess={(credentialResponse: any) => {
            axios
              .post(
                `${process.env.REACT_APP_BASE_URL}/googleAuthenticate`,
                credentialResponse,
              )
              .then((res) => {
                if (res.data.result.status === 200) {
                  const response = res.data.result
                  const token = response.data.userToken.access_token

                  localStorage.setItem('token', token)
                  const userDecode = jwtDecode(token) as any
                  setUser(userDecode)
                  setToken(token)
                  if (userDecode.approved === 'approved') {
                    window.location.href = '/panel'
                  } else {
                    window.location.href = '/accessvalidation'
                  }
                } else {
                  const response = res.data.result
                  setGoogleEmail(response.data.email)
                  setGoogleName(response.data.name)
                  setGooglePicture(response.data.picture)

                  if (googleEmail && googleName) {
                    window.location.href = '/completeRegister'
                  }
                }
              })
              .catch((err) => {
                console.log(err)
              })
          }}
          onError={() => {
            console.log('Login Failed')
          }}
        />
      </GoogleDiv>

      <RegisterDiv onClick={() => changePage('Register')}>
        <p> Fazer cadastro </p>
      </RegisterDiv>
    </Container>
  ) : (
    <CompleteRegister />
  )
}

export default MainBox
